// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options,
  changeSpecialOfferStatus,
  changeAccountAssignmentFileStatus,
  deleteSpecialOffer,
  getSpecialOffer,
  updateSpecialOffer,
  deleteSegmentedStore,
  getSegmentedStore,
  updateSegmentedStore,
  changeSegmentedStoreStatus,
  markSegmentedStoreAsDefault,
  createSpecialOfferPurchase,
  createPurchase,
  callback,
  getSpecialOfferItems,
  addSpecialOfferItem,
  upsertAssignments,
  getAccountAssignmentFilesProcessingHistory,
  assignAccountsFileUpload,
  getSpecialOfferView,
  addSpecialOffer,
  getSegmentedStoresListView,
  addSegmentedStore,
  getStoreItems,
  addStoreItem,
  getConfig,
  updateConfig,
  getPurchase,
  offers,
  deleteSpecialOfferItem,
  getSpecialOfferItem,
  deleteStoreItem,
  getStoreItem,
  getDefaultImages,
} from '../sdk.gen'
import { type UseMutationOptions, queryOptions } from '@tanstack/react-query'
import type {
  ChangeSpecialOfferStatusData,
  ChangeSpecialOfferStatusError,
  ChangeSpecialOfferStatusResponse,
  ChangeAccountAssignmentFileStatusData,
  ChangeAccountAssignmentFileStatusError,
  ChangeAccountAssignmentFileStatusResponse,
  DeleteSpecialOfferData,
  DeleteSpecialOfferError,
  DeleteSpecialOfferResponse,
  GetSpecialOfferData,
  UpdateSpecialOfferData,
  UpdateSpecialOfferError,
  UpdateSpecialOfferResponse,
  DeleteSegmentedStoreData,
  DeleteSegmentedStoreError,
  DeleteSegmentedStoreResponse,
  GetSegmentedStoreData,
  UpdateSegmentedStoreData,
  UpdateSegmentedStoreError,
  UpdateSegmentedStoreResponse,
  ChangeSegmentedStoreStatusData,
  ChangeSegmentedStoreStatusError,
  ChangeSegmentedStoreStatusResponse,
  MarkSegmentedStoreAsDefaultData,
  MarkSegmentedStoreAsDefaultError,
  MarkSegmentedStoreAsDefaultResponse,
  CreateSpecialOfferPurchaseData,
  CreateSpecialOfferPurchaseError,
  CreateSpecialOfferPurchaseResponse,
  CreatePurchaseData,
  CreatePurchaseError,
  CreatePurchaseResponse,
  CallbackData,
  CallbackError,
  CallbackResponse,
  GetSpecialOfferItemsData,
  AddSpecialOfferItemData,
  AddSpecialOfferItemError,
  AddSpecialOfferItemResponse,
  UpsertAssignmentsData,
  UpsertAssignmentsError,
  UpsertAssignmentsResponse,
  GetAccountAssignmentFilesProcessingHistoryData,
  AssignAccountsFileUploadData,
  AssignAccountsFileUploadError,
  AssignAccountsFileUploadResponse,
  GetSpecialOfferViewData,
  AddSpecialOfferData,
  AddSpecialOfferError,
  AddSpecialOfferResponse,
  GetSegmentedStoresListViewData,
  AddSegmentedStoreData,
  AddSegmentedStoreError,
  AddSegmentedStoreResponse,
  GetStoreItemsData,
  AddStoreItemData,
  AddStoreItemError,
  AddStoreItemResponse,
  GetConfigData,
  UpdateConfigData,
  UpdateConfigError,
  UpdateConfigResponse,
  GetPurchaseData,
  OffersData,
  DeleteSpecialOfferItemData,
  DeleteSpecialOfferItemError,
  DeleteSpecialOfferItemResponse,
  GetSpecialOfferItemData,
  DeleteStoreItemData,
  DeleteStoreItemError,
  DeleteStoreItemResponse,
  GetStoreItemData,
  GetDefaultImagesData,
} from '../types.gen'
import { client as _heyApiClient } from '../client.gen'

export const changeSpecialOfferStatusMutation = (
  options?: Partial<Options<ChangeSpecialOfferStatusData>>,
): UseMutationOptions<
  ChangeSpecialOfferStatusResponse,
  ChangeSpecialOfferStatusError,
  Options<ChangeSpecialOfferStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    ChangeSpecialOfferStatusResponse,
    ChangeSpecialOfferStatusError,
    Options<ChangeSpecialOfferStatusData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await changeSpecialOfferStatus({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const changeAccountAssignmentFileStatusMutation = (
  options?: Partial<Options<ChangeAccountAssignmentFileStatusData>>,
): UseMutationOptions<
  ChangeAccountAssignmentFileStatusResponse,
  ChangeAccountAssignmentFileStatusError,
  Options<ChangeAccountAssignmentFileStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    ChangeAccountAssignmentFileStatusResponse,
    ChangeAccountAssignmentFileStatusError,
    Options<ChangeAccountAssignmentFileStatusData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await changeAccountAssignmentFileStatus({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteSpecialOfferMutation = (
  options?: Partial<Options<DeleteSpecialOfferData>>,
): UseMutationOptions<
  DeleteSpecialOfferResponse,
  DeleteSpecialOfferError,
  Options<DeleteSpecialOfferData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteSpecialOfferResponse,
    DeleteSpecialOfferError,
    Options<DeleteSpecialOfferData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteSpecialOffer({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const getSpecialOfferQueryKey = (
  options: Options<GetSpecialOfferData>,
) => createQueryKey('getSpecialOffer', options)

export const getSpecialOfferOptions = (
  options: Options<GetSpecialOfferData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSpecialOffer({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSpecialOfferQueryKey(options),
  })
}

export const updateSpecialOfferMutation = (
  options?: Partial<Options<UpdateSpecialOfferData>>,
): UseMutationOptions<
  UpdateSpecialOfferResponse,
  UpdateSpecialOfferError,
  Options<UpdateSpecialOfferData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateSpecialOfferResponse,
    UpdateSpecialOfferError,
    Options<UpdateSpecialOfferData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateSpecialOffer({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteSegmentedStoreMutation = (
  options?: Partial<Options<DeleteSegmentedStoreData>>,
): UseMutationOptions<
  DeleteSegmentedStoreResponse,
  DeleteSegmentedStoreError,
  Options<DeleteSegmentedStoreData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteSegmentedStoreResponse,
    DeleteSegmentedStoreError,
    Options<DeleteSegmentedStoreData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteSegmentedStore({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getSegmentedStoreQueryKey = (
  options: Options<GetSegmentedStoreData>,
) => createQueryKey('getSegmentedStore', options)

export const getSegmentedStoreOptions = (
  options: Options<GetSegmentedStoreData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSegmentedStore({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSegmentedStoreQueryKey(options),
  })
}

export const updateSegmentedStoreMutation = (
  options?: Partial<Options<UpdateSegmentedStoreData>>,
): UseMutationOptions<
  UpdateSegmentedStoreResponse,
  UpdateSegmentedStoreError,
  Options<UpdateSegmentedStoreData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateSegmentedStoreResponse,
    UpdateSegmentedStoreError,
    Options<UpdateSegmentedStoreData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateSegmentedStore({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const changeSegmentedStoreStatusMutation = (
  options?: Partial<Options<ChangeSegmentedStoreStatusData>>,
): UseMutationOptions<
  ChangeSegmentedStoreStatusResponse,
  ChangeSegmentedStoreStatusError,
  Options<ChangeSegmentedStoreStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    ChangeSegmentedStoreStatusResponse,
    ChangeSegmentedStoreStatusError,
    Options<ChangeSegmentedStoreStatusData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await changeSegmentedStoreStatus({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const markSegmentedStoreAsDefaultMutation = (
  options?: Partial<Options<MarkSegmentedStoreAsDefaultData>>,
): UseMutationOptions<
  MarkSegmentedStoreAsDefaultResponse,
  MarkSegmentedStoreAsDefaultError,
  Options<MarkSegmentedStoreAsDefaultData>
> => {
  const mutationOptions: UseMutationOptions<
    MarkSegmentedStoreAsDefaultResponse,
    MarkSegmentedStoreAsDefaultError,
    Options<MarkSegmentedStoreAsDefaultData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await markSegmentedStoreAsDefault({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const createSpecialOfferPurchaseQueryKey = (
  options: Options<CreateSpecialOfferPurchaseData>,
) => createQueryKey('createSpecialOfferPurchase', options)

export const createSpecialOfferPurchaseOptions = (
  options: Options<CreateSpecialOfferPurchaseData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createSpecialOfferPurchase({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createSpecialOfferPurchaseQueryKey(options),
  })
}

export const createSpecialOfferPurchaseMutation = (
  options?: Partial<Options<CreateSpecialOfferPurchaseData>>,
): UseMutationOptions<
  CreateSpecialOfferPurchaseResponse,
  CreateSpecialOfferPurchaseError,
  Options<CreateSpecialOfferPurchaseData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateSpecialOfferPurchaseResponse,
    CreateSpecialOfferPurchaseError,
    Options<CreateSpecialOfferPurchaseData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createSpecialOfferPurchase({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const createPurchaseQueryKey = (options: Options<CreatePurchaseData>) =>
  createQueryKey('createPurchase', options)

export const createPurchaseOptions = (options: Options<CreatePurchaseData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createPurchase({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createPurchaseQueryKey(options),
  })
}

export const createPurchaseMutation = (
  options?: Partial<Options<CreatePurchaseData>>,
): UseMutationOptions<
  CreatePurchaseResponse,
  CreatePurchaseError,
  Options<CreatePurchaseData>
> => {
  const mutationOptions: UseMutationOptions<
    CreatePurchaseResponse,
    CreatePurchaseError,
    Options<CreatePurchaseData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createPurchase({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const callbackQueryKey = (options: Options<CallbackData>) =>
  createQueryKey('callback', options)

export const callbackOptions = (options: Options<CallbackData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await callback({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: callbackQueryKey(options),
  })
}

export const callbackMutation = (
  options?: Partial<Options<CallbackData>>,
): UseMutationOptions<
  CallbackResponse,
  CallbackError,
  Options<CallbackData>
> => {
  const mutationOptions: UseMutationOptions<
    CallbackResponse,
    CallbackError,
    Options<CallbackData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await callback({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getSpecialOfferItemsQueryKey = (
  options: Options<GetSpecialOfferItemsData>,
) => createQueryKey('getSpecialOfferItems', options)

export const getSpecialOfferItemsOptions = (
  options: Options<GetSpecialOfferItemsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSpecialOfferItems({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSpecialOfferItemsQueryKey(options),
  })
}

export const addSpecialOfferItemQueryKey = (
  options: Options<AddSpecialOfferItemData>,
) => createQueryKey('addSpecialOfferItem', options)

export const addSpecialOfferItemOptions = (
  options: Options<AddSpecialOfferItemData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await addSpecialOfferItem({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: addSpecialOfferItemQueryKey(options),
  })
}

export const addSpecialOfferItemMutation = (
  options?: Partial<Options<AddSpecialOfferItemData>>,
): UseMutationOptions<
  AddSpecialOfferItemResponse,
  AddSpecialOfferItemError,
  Options<AddSpecialOfferItemData>
> => {
  const mutationOptions: UseMutationOptions<
    AddSpecialOfferItemResponse,
    AddSpecialOfferItemError,
    Options<AddSpecialOfferItemData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await addSpecialOfferItem({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const upsertAssignmentsQueryKey = (
  options: Options<UpsertAssignmentsData>,
) => createQueryKey('upsertAssignments', options)

export const upsertAssignmentsOptions = (
  options: Options<UpsertAssignmentsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await upsertAssignments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: upsertAssignmentsQueryKey(options),
  })
}

export const upsertAssignmentsMutation = (
  options?: Partial<Options<UpsertAssignmentsData>>,
): UseMutationOptions<
  UpsertAssignmentsResponse,
  UpsertAssignmentsError,
  Options<UpsertAssignmentsData>
> => {
  const mutationOptions: UseMutationOptions<
    UpsertAssignmentsResponse,
    UpsertAssignmentsError,
    Options<UpsertAssignmentsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await upsertAssignments({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAccountAssignmentFilesProcessingHistoryQueryKey = (
  options: Options<GetAccountAssignmentFilesProcessingHistoryData>,
) => createQueryKey('getAccountAssignmentFilesProcessingHistory', options)

export const getAccountAssignmentFilesProcessingHistoryOptions = (
  options: Options<GetAccountAssignmentFilesProcessingHistoryData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAccountAssignmentFilesProcessingHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAccountAssignmentFilesProcessingHistoryQueryKey(options),
  })
}

export const assignAccountsFileUploadQueryKey = (
  options: Options<AssignAccountsFileUploadData>,
) => createQueryKey('assignAccountsFileUpload', options)

export const assignAccountsFileUploadOptions = (
  options: Options<AssignAccountsFileUploadData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await assignAccountsFileUpload({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: assignAccountsFileUploadQueryKey(options),
  })
}

export const assignAccountsFileUploadMutation = (
  options?: Partial<Options<AssignAccountsFileUploadData>>,
): UseMutationOptions<
  AssignAccountsFileUploadResponse,
  AssignAccountsFileUploadError,
  Options<AssignAccountsFileUploadData>
> => {
  const mutationOptions: UseMutationOptions<
    AssignAccountsFileUploadResponse,
    AssignAccountsFileUploadError,
    Options<AssignAccountsFileUploadData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await assignAccountsFileUpload({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getSpecialOfferViewQueryKey = (
  options: Options<GetSpecialOfferViewData>,
) => createQueryKey('getSpecialOfferView', options)

export const getSpecialOfferViewOptions = (
  options: Options<GetSpecialOfferViewData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSpecialOfferView({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSpecialOfferViewQueryKey(options),
  })
}

export const addSpecialOfferQueryKey = (
  options: Options<AddSpecialOfferData>,
) => createQueryKey('addSpecialOffer', options)

export const addSpecialOfferOptions = (
  options: Options<AddSpecialOfferData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await addSpecialOffer({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: addSpecialOfferQueryKey(options),
  })
}

export const addSpecialOfferMutation = (
  options?: Partial<Options<AddSpecialOfferData>>,
): UseMutationOptions<
  AddSpecialOfferResponse,
  AddSpecialOfferError,
  Options<AddSpecialOfferData>
> => {
  const mutationOptions: UseMutationOptions<
    AddSpecialOfferResponse,
    AddSpecialOfferError,
    Options<AddSpecialOfferData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await addSpecialOffer({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getSegmentedStoresListViewQueryKey = (
  options: Options<GetSegmentedStoresListViewData>,
) => createQueryKey('getSegmentedStoresListView', options)

export const getSegmentedStoresListViewOptions = (
  options: Options<GetSegmentedStoresListViewData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSegmentedStoresListView({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSegmentedStoresListViewQueryKey(options),
  })
}

export const addSegmentedStoreQueryKey = (
  options: Options<AddSegmentedStoreData>,
) => createQueryKey('addSegmentedStore', options)

export const addSegmentedStoreOptions = (
  options: Options<AddSegmentedStoreData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await addSegmentedStore({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: addSegmentedStoreQueryKey(options),
  })
}

export const addSegmentedStoreMutation = (
  options?: Partial<Options<AddSegmentedStoreData>>,
): UseMutationOptions<
  AddSegmentedStoreResponse,
  AddSegmentedStoreError,
  Options<AddSegmentedStoreData>
> => {
  const mutationOptions: UseMutationOptions<
    AddSegmentedStoreResponse,
    AddSegmentedStoreError,
    Options<AddSegmentedStoreData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await addSegmentedStore({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getStoreItemsQueryKey = (options: Options<GetStoreItemsData>) =>
  createQueryKey('getStoreItems', options)

export const getStoreItemsOptions = (options: Options<GetStoreItemsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getStoreItems({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getStoreItemsQueryKey(options),
  })
}

export const addStoreItemQueryKey = (options: Options<AddStoreItemData>) =>
  createQueryKey('addStoreItem', options)

export const addStoreItemOptions = (options: Options<AddStoreItemData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await addStoreItem({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: addStoreItemQueryKey(options),
  })
}

export const addStoreItemMutation = (
  options?: Partial<Options<AddStoreItemData>>,
): UseMutationOptions<
  AddStoreItemResponse,
  AddStoreItemError,
  Options<AddStoreItemData>
> => {
  const mutationOptions: UseMutationOptions<
    AddStoreItemResponse,
    AddStoreItemError,
    Options<AddStoreItemData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await addStoreItem({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getConfigQueryKey = (options: Options<GetConfigData>) =>
  createQueryKey('getConfig', options)

export const getConfigOptions = (options: Options<GetConfigData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getConfigQueryKey(options),
  })
}

export const updateConfigQueryKey = (options: Options<UpdateConfigData>) =>
  createQueryKey('updateConfig', options)

export const updateConfigOptions = (options: Options<UpdateConfigData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: updateConfigQueryKey(options),
  })
}

export const updateConfigMutation = (
  options?: Partial<Options<UpdateConfigData>>,
): UseMutationOptions<
  UpdateConfigResponse,
  UpdateConfigError,
  Options<UpdateConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateConfigResponse,
    UpdateConfigError,
    Options<UpdateConfigData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateConfig({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getPurchaseQueryKey = (options: Options<GetPurchaseData>) =>
  createQueryKey('getPurchase', options)

export const getPurchaseOptions = (options: Options<GetPurchaseData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPurchase({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPurchaseQueryKey(options),
  })
}

export const offersQueryKey = (options?: Options<OffersData>) =>
  createQueryKey('offers', options)

export const offersOptions = (options?: Options<OffersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await offers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: offersQueryKey(options),
  })
}

export const deleteSpecialOfferItemMutation = (
  options?: Partial<Options<DeleteSpecialOfferItemData>>,
): UseMutationOptions<
  DeleteSpecialOfferItemResponse,
  DeleteSpecialOfferItemError,
  Options<DeleteSpecialOfferItemData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteSpecialOfferItemResponse,
    DeleteSpecialOfferItemError,
    Options<DeleteSpecialOfferItemData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteSpecialOfferItem({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getSpecialOfferItemQueryKey = (
  options: Options<GetSpecialOfferItemData>,
) => createQueryKey('getSpecialOfferItem', options)

export const getSpecialOfferItemOptions = (
  options: Options<GetSpecialOfferItemData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSpecialOfferItem({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSpecialOfferItemQueryKey(options),
  })
}

export const deleteStoreItemMutation = (
  options?: Partial<Options<DeleteStoreItemData>>,
): UseMutationOptions<
  DeleteStoreItemResponse,
  DeleteStoreItemError,
  Options<DeleteStoreItemData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteStoreItemResponse,
    DeleteStoreItemError,
    Options<DeleteStoreItemData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteStoreItem({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getStoreItemQueryKey = (options: Options<GetStoreItemData>) =>
  createQueryKey('getStoreItem', options)

export const getStoreItemOptions = (options: Options<GetStoreItemData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getStoreItem({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getStoreItemQueryKey(options),
  })
}

export const getDefaultImagesQueryKey = (
  options: Options<GetDefaultImagesData>,
) => createQueryKey('getDefaultImages', options)

export const getDefaultImagesOptions = (
  options: Options<GetDefaultImagesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDefaultImages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getDefaultImagesQueryKey(options),
  })
}
